import { DropdownOption } from 'components/final-form/dropdownUtils';
import React, { Component } from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { Grid, Header } from 'semantic-ui-react';
import { Field } from 'react-final-form';
import DatePicker from 'components/final-form/DatePicker';
import { required } from 'utils/validatorUtils';
import Select from 'components/final-form/Select';
import PxGrid from 'components/layout/PxGrid';
import CheckBox from 'components/final-form/CheckBox';

interface Props extends MessageSourceProps {
  mandateBanks: Array<DropdownOption>
}

class CollectiveBillAdditionalInfo extends Component<Props> {


  render(): React.ReactElement {

    const {mandateBanks, getMessage} = this.props;

    return (
        <PxGrid>
          <Grid.Row>
            <Grid.Column width={8}>
              <Header>{getMessage("additional.info")}</Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign={"middle"}>
              {getMessage("date")}:
            </Grid.Column>
            <Grid.Column width={2} verticalAlign={"middle"}>
              <Field
                  name="date"
                  component={DatePicker}
                  validate={required}
                  fluid
              />
            </Grid.Column>
            <Grid.Column widescreen={3} verticalAlign="middle">
              <Field
                  name="detailProofList"
                  component={CheckBox}
                  label={getMessage("detailProofList")}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign={"middle"}>
              {getMessage("bill.bank")}:
            </Grid.Column>
            <Grid.Column width={5} verticalAlign={"middle"}>
              <Field
                  name="bankId"
                  component={Select}
                  options={mandateBanks}
                  upward
                  fluid
              />
            </Grid.Column>
          </Grid.Row>
        </PxGrid>
    );
  };

}

export default withMessages(CollectiveBillAdditionalInfo);
